import axiosClient from 'axios';
import cookie from 'react-cookies';
import {isEmpty} from "../components/helpers/helpers";


const axios = (() => {
    var mainInstance = axiosClient.create();

    mainInstance.defaults.baseURL = process.env.NEXT_PUBLIC_API_BASE_URL;
    mainInstance.defaults.headers['Client-Token'] = '598eec18374b5';
    mainInstance.defaults.headers['post']['Content-Type'] = 'application/x-www-form-urlencoded';

    // add auth token to headers
    if (process.browser) {
        //let session = localStorage.getItem('session_id');
        const token = cookie.load('auth_token');

        if (token) {
            mainInstance.defaults.headers['Auth-Token'] = token
        }
    }

    const fingerprint = cookie.load('fingerprint');

    if (!isEmpty(fingerprint)) {
        mainInstance.defaults.headers['Session'] = fingerprint;
    }

    return mainInstance
})();

export {axios};